<template>
    <!-- 图标组件 -->
    <i class="vel-icon" 
    :class="[
        iconName,
        {'vel-icon-primary':type==='primary'},
        {'vel-icon-success':type==='success'},
        {'vel-icon-info':type==='info'},
        {'vel-icon-warning':type==='warning'},
        {'vel-icon-danger':type==='danger'},
    ]"
    >{{iconText}}</i>
</template>
<script>
export default {
    name:"VelIcon",
    props:{
        iconName:String,
        iconText:String,
        type:String,
    },
    data() {
        return {
            
        };
    }
}
</script>
<style scoped>
.vel-icon{
    text-decoration: none;
}
.vel-icon-primary{
    color: #409eff;
}
.vel-icon-success{
    color: #67c23a;
}
.vel-icon-info{
    color: #909399;
}
.vel-icon-warning{
    color: #e6a23c;
}
.vel-icon-danger{
    color: #f56c6c;
}
</style>